var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"customer-main"},[_c('div',{staticClass:"customer-title"},[_vm._v("客服")]),_c('div',{staticClass:"answers"},[_c('span',[_vm._v("如有问题，请点击右上角客服按钮！")])])])])
}]

export { render, staticRenderFns }